module.exports = __webpack_public_path__ + "static/media/enterprise_project_selected.af0622c6.svg";